import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	scrollBar: {
		maxHeight: 400,
		overflowY: "auto",
		width: "100%",
		margin: "15px 0px"
	},
	centralizedButton: {
		justifyContent: "center",
		alignItems: "center"
	},
	newFeatureItem: {
		fontWeight: "bold",
		cursor: "pointer",
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[500]),
		color: colors.gray[0],
		marginLeft: 4
	},
	validationDialogCancelButton: {
		padding: theme.spacing(1.25, 4),
		fontSize: theme.spacing(1.75),
		height: theme.spacing(5)
	},
	validationDialogSaveButton: {
		padding: theme.spacing(1.25, 4),
		...ColorUtil.getBackgroundAndContrastColor(colors.red[50]),
		fontSize: theme.spacing(1.75),
		height: theme.spacing(5),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.red[200])
		}
	},
	warningContainer: {
		gap: 24
	},
	picture: {
		width: "60%"
	},
	singleContactPadding: {
		padding: theme.spacing(2, 3.75)
	},
	multipleContactsPadding: {
		padding: theme.spacing(2)
	}
}))

export default useStyles
